import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CohortBandItem, InsightGroup, ReadinessKpis, Student } from '../../models/college-dashboard.model';
import { CollegeDashboardService } from '../../services/college-dashboard.service';
import { KpiRowComponent } from '../../components/readiness/kpi-row/kpi-row.component';
import { CohortDonutComponent } from '../../components/readiness/cohort-donut/cohort-donut.component';
import { DimensionGridComponent } from '../../components/readiness/dimension-grid/dimension-grid.component';
import { AiInsightsComponent } from '../../components/readiness/ai-insights/ai-insights.component';

@Component({
  selector: 'app-college-readiness',
  standalone: true,
  imports: [
    CommonModule,
    KpiRowComponent,
    CohortDonutComponent,
    DimensionGridComponent,
    AiInsightsComponent
  ],
  templateUrl: './college-readiness.component.html',
  styleUrl: './college-readiness.component.scss'
})
export class CollegeReadinessComponent implements OnInit {
  @Output() selectStudent = new EventEmitter<Student>();

  kpis!: ReadinessKpis;
  cohort: CohortBandItem[] = [];
  insightGroups: InsightGroup[] = [];
  academicYear: string = 'All Years';
  department: string = 'All Departments';

  constructor(private dashboardService: CollegeDashboardService) {}

  ngOnInit(): void {
    this.kpis = this.dashboardService.getReadinessKpis();
    this.cohort = this.dashboardService.getCohortData();
    this.insightGroups = this.dashboardService.getAiInsights();

    this.dashboardService.settings$.subscribe((settings) => {
      this.academicYear = settings.academicYear;
      this.department = settings.department;
    });
  }
}
